// instrument.js — DOIT être le premier import dans src/index.jsx
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN ?? 'https://7c9a0f98bb9249c77f1ae8404a16af00@o4511176076689408.ingest.de.sentry.io/4511176117911632',
  environment: import.meta.env.MODE || 'production',
  sendDefaultPii: true,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Tracing
  tracesSampleRate: 0.1,
  tracePropagationTargets: ['localhost', /^https:\/\/api\.akodigitale\.fr/],

  // Session Replay — 10% des sessions, 100% sur erreur
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  enableLogs: true,
});
